import { useEffect, useState } from 'react'

import _ from 'lodash'
import { useRouter } from 'next/router'

const ScrollingHeatmap = (props) => {
  const divisions = 20
  const router = useRouter()
  const emptyArray = []
  for (let i = 0; i < divisions; i++) emptyArray[i] = 0
  const [points, setPoints] = useState(emptyArray)
  const [prevPath, setPrevPath] = useState(router.pathname)

  const sendData = () => {
    setPrevPath(router.pathname)
    setPoints(emptyArray)
  }

  const updateMap = () => {
    if (document.visibilityState !== 'visible') return
    const el = document.scrollingElement
    if (el.clientHeight === el.scrollHeight) return
    const loc = el.scrollTop / (el.scrollHeight - el.clientHeight)
    const idx = Math.min(Math.floor(loc * divisions), divisions - 1)
    const newPoints = points
      .slice(0, idx)
      .concat(points[idx] + 1)
      .concat(points.slice(idx + 1))
    setPoints(newPoints)
    // console.log(newPoints)
  }

  useEffect(() => {
    const timer = setInterval(updateMap, 2000)
    router.events.on('routeChangeStart', sendData)
    return () => {
      router.events.off('routeChangeStart', sendData)
      clearInterval(timer)
    }
  })

  useEffect(() => {
    window.addEventListener('beforeunload', sendData)
    return () => window.removeEventListener('beforeunload', sendData)
  })
  return <></>
}

export default ScrollingHeatmap
